import { ChatCustomization, UtmForwardingSource } from 'app/copied/types/ChatItems';

export default function getUtmParams(feConfig: ChatCustomization['fe_config']) {
  if (!feConfig) {
    return new URLSearchParams();
  }

  const utmForwarding = feConfig.analytics?.utmForwarding;
  const params = utmForwarding?.params || [];

  let sourceParams: URLSearchParams = new URLSearchParams();

  switch (utmForwarding?.source) {
    case UtmForwardingSource.URL:
      sourceParams = new URLSearchParams(window.location.search);
      break;
    case UtmForwardingSource.SESSION_STORAGE:
      params.forEach((param) => {
        const value = window.sessionStorage.getItem(param);
        if (value) {
          sourceParams.set(param, value);
        }
      });
      break;
    case UtmForwardingSource.LOCAL_STORAGE:
      params.forEach((param) => {
        const value = window.localStorage.getItem(param);
        if (value) {
          sourceParams.set(param, value);
        }
      });
      break;
    default:
      return new URLSearchParams();
  }

  if (params.length === 0) {
    return sourceParams;
  }

  const result = new URLSearchParams();

  params.forEach((param) => {
    const value = sourceParams.get(param);
    if (value) {
      result.set(param, value);
    }
  });

  return result;
}
